export const INTERNAL_ERROR = 'An internal error has occurred. try again or contact the administrator.';
export const NETWORK_ERROR = 'No Internet Connection.';